import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'do_operators_technicians_install_boiler'

export const dataPointDefinition = {
  retracedId: 'do_operators_technicians_install_boiler',
  name: 'Do operators/ technicians for machinery, equipment, electrical installations, boiler, lifting equipment, and/or welding ',
  description:
    'This question covers legally required training for workers to use machines and equipment safely (e.g., sewing machines, cutting machines, etc.), as well as ensuring that operators / technicians for machinery, equipment, electrical installations, boiler, lifting equipment, and/or welding have legally',
  meta: {
    slcpMeta: {
      key: 'hs-32-12x',
      number: 'HS-WOR-17',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-32-12x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29320,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
